/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useRef } from 'react';
import { Card, Form, Button, Modal, InputGroup } from 'react-bootstrap';
import * as S from './style';
import { MdCancel } from 'react-icons/md';
import { OTPComp } from './component';
export interface IVerificationModel {
  showModal?: boolean;
  createModalLabel?: string;
  nameLabel?: string;
  submitButtonText?: string;
  signupButtonStyle?: any;
  email?: string;
  phoneNumber?: any;
  defaultDescription?: string;
  onAcknowledgement?(name: string, description: string): void;
  onDeny?(): void;
  onOTPSubmit?(data: any): void;
  resendOtpClick?(): void;
}

export const VerificationModal = ({
  showModal,
  createModalLabel,
  nameLabel,
  email,
  phoneNumber,
  submitButtonText,
  signupButtonStyle,
  onDeny,
  onAcknowledgement,
  defaultProfileImg,
  onOTPSubmit,
  resendOtpClick,
}: IVerificationModel) => {
  const [show, setShow] = useState(showModal);
  const [otp, setOtp] = useState();

  const handleClose = () => {
    if (onDeny) {
      onDeny();
    }
    setShow(false);
  };
  const handleSubmit = (event: any) => {
    if (event) {
      event.preventDefault();
      if (onAcknowledgement) {
        onAcknowledgement(otp);
      }
    }
    setShow(false);
  };

  const onOTPChange = (value: string) => {
    setOtp(value);
  };
  const renderSubmitButton = () => {
    return (
      <div className="text-center mb-2">
        <Button variant="secondary" type="submit" className="modal-button me-3">
          {submitButtonText}
        </Button>
      </div>
    );
  };

  return (
    <Modal centered show={show} onHide={handleClose} backdrop="static">
      <Modal.Header className="border-2 border-dark">
        <S.Header>{nameLabel}</S.Header>
        {/* <Button variant="close" aria-label="Close" onClick={handleClose} ><MdCancel></MdCancel></Button> */}
        <S.Cancel onClick={handleClose}>
          <MdCancel />
        </S.Cancel>
      </Modal.Header>
      {/* <hr></hr> */}
      <Modal.Body className="p-0">
        <Card border="light" className="px-0 px-md-4 py-0 border-0">
          <Card.Body>
            <div className="mb-5">
              {/* <OTPInputComp onOTPChange={onOTPChange} /> */}
              <OTPComp
                email={email}
                phoneNumber={phoneNumber}
                onFormSubmit={onOTPSubmit}
                onResendClick={resendOtpClick}
                renderSubmitButton={renderSubmitButton}
              />
            </div>
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

VerificationModal.defaultProps = {
  showModal: false,
  createModalLabel: 'A one time password has been sent to',
  nameLabel: 'Please enter the One-Time Password to verify your email address ',
  submitButtonText: 'Validate',
  signupButtonStyle: {
    backgroundColor: '#D1D100',
    color: 'black',
    marginBottom: '5%',
  },
};
